import { partition } from 'lodash';
import createCachedSelector from 're-reselect';

import { MetrikaCounterEditorSelectItem } from '../../components/MetrikaCounterEditor/MetrikaCounterEditor';
import { metrikaCounterEditorInitialData } from '../../service/MetrikaCounterEditor/MetrikaCounterEditor';
import { MetrikaCounterEditorData } from '../../typings/metrikaCounterEditor';
import { State } from '../../typings/state';

export const selectMetrikaCounterEditorById = (state: State, editorId: string): MetrikaCounterEditorData => {
    return state.metrikaCounterEditor.editors[editorId] || metrikaCounterEditorInitialData;
};

export const selectCountersMetrikaCounterEditor = createCachedSelector(
    (state: State, savedCounters: string[]) => state.metrikaCounterEditor.counters,
    (state: State, savedCounters: string[]) => savedCounters,
    (counters?: string[], savedCounters?: string[]): MetrikaCounterEditorSelectItem[] | undefined => {
        if (!counters) {
            return undefined;
        }

        const availableCountersMap = (counters || []).reduce((acc, counter) => {
            return { ...acc, [counter]: true };
        }, {});

        const [savedSelectedCounters, deletedSelectedCounters] = partition(
            savedCounters,
            counter => availableCountersMap[counter]
        );

        const savedCountersMap = savedSelectedCounters.reduce((acc, counter: string) => {
            return { ...acc, [counter]: true };
        }, {});

        const deselectedCounters = counters.filter(counter => !savedCountersMap[counter]);

        return [
            ...deletedSelectedCounters.map((counter: string) => ({
                counter,
                isDeleted: true
            })),
            ...savedSelectedCounters.map((counter: string) => ({
                counter,
                isDeleted: false
            })),
            ...deselectedCounters.map((counter: string) => ({
                counter,
                isDeleted: false
            }))
        ];
    }
)((state: State, savedCounters: string[]) => savedCounters.toString());
